import AdminSettings from 'components/Admin/Settings/AdminSettings';
import { FC } from 'react';

const AdminSettingsListPage: FC = () => {
	return <AdminSettings />;
};

export default AdminSettingsListPage;
